import { createFileRoute } from '@tanstack/react-router'
import KohBusPaymentSuccess from '@/components/make-booking/payment/PaymentSuccess'

export const Route = createFileRoute('/make-booking/$id/payment/success')({
  component: RouteComponent,
})

function RouteComponent() {
  return <KohBusPaymentSuccess />
}
